import {
    processImageTags,
    processAnchorTags,
    appendIdAttributeAfterNameAttribute } from './_private/HTMLUtil';
import RestService from './_private/RestService';

export default class WikiService {

    private restService = new RestService();

    /**
     * @throws {Error}
     */
    public async getPage(pageName: string): Promise<any> {
        let content = await this.restService.getStaticPage(pageName);
        content = processImageTags(content);
        content = appendIdAttributeAfterNameAttribute(content);
        return processAnchorTags(content);
    }
}

export const wikiService = new WikiService();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/wiki/WikiService.ts